// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumb_wrapper__3agHH","link":"Breadcrumb_link__3Dxtg"};